"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HorizintalStackComponent = void 0;
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
const _excluded = ["spacing", "width", "height", "bg", "borderRadius", "justifyContent", "alignItems", "minWidth", "maxWidth"];
const HorizintalStackComponent = exports.HorizintalStackComponent = _styledComponents.default.div`
	${_ref => {
  let {
      spacing,
      width,
      height,
      bg,
      borderRadius,
      justifyContent,
      alignItems,
      minWidth,
      maxWidth
    } = _ref,
    props = (0, _objectWithoutPropertiesLoose2.default)(_ref, _excluded);
  return `
      gap: ${spacing}; 
      width: ${width};
      height: ${height}; 
      background: ${bg}; 
      border-radius: ${borderRadius};
      justify-content: ${justifyContent};
      align-items: ${alignItems};
      min-width:${minWidth};
      max-width:${maxWidth};
      display: flex;
	flex-direction: row;
`;
}}
`;